import type { ConnectorDeviceDescription } from "../../api/connectorsApi";

/** Node's names of operating systems (`process.platform`), as people know them. */
const OPERATING_SYSTEM_NAMES: Readonly<Record<string, string>> = {
  win32: "Windows",
  darwin: "macOS",
  linux: "Linux",
};

/** `Windows, x64`; a system Node names otherwise is shown as reported. */
export function platformText(device: ConnectorDeviceDescription): string {
  const operatingSystem = OPERATING_SYSTEM_NAMES[device.platformOs] ?? device.platformOs;
  return `${operatingSystem}, ${device.platformArch}`;
}
